import { useContext } from 'react';
import { ImagePreviewContext } from './provider';

export const useImagePreview = () => useContext(ImagePreviewContext);
